import React, { ReactNode, useContext } from 'react';
import SideNavContentContainer, {
  SideNavContentContainerProps,
} from './components/SideNavContentContainer/SideNavContentContainer';
import SideNavDivider from './components/SideNavDivider/SideNavDivider';
import SideNavGroup from './components/SideNavGroup/SideNavGroup';
import SideNavGroupToggle, { SideNavGroupToggleProps } from './components/SideNavGroupToggle/SideNavGroupToggle';
import SideNavItem, { SideNavItemProps } from './components/SideNavItem/SideNavItem';
import { SideNavContext } from './SideNavContext';
import { StyledSideNav, StyledSideNavWrapper } from './styles';

interface SideNavProps extends React.HTMLAttributes<HTMLElement> {
  children: ReactNode;
  hideFilter?: boolean;
  width?: string;
}

const SideNav = (props: SideNavProps) => {
  const { hideFilter, width, children, ...otherProps } = props;
  const { isCompact, isMobile } = useContext(SideNavContext);

  return (
    <StyledSideNavWrapper isMobile={isMobile} isCompact={isCompact}>
      <StyledSideNav
        {...otherProps}
        $width={width}
        isCompact={isCompact}
        isMobile={isMobile}
        hideFilter={hideFilter}
        children={children}
      />
    </StyledSideNavWrapper>
  );
};

SideNav.displayName = 'SideNav';

SideNav.ContentContainer = SideNavContentContainer;
SideNav.Divider = SideNavDivider;
SideNav.Group = SideNavGroup;
SideNav.GroupToggle = SideNavGroupToggle;
SideNav.Item = SideNavItem;
SideNav.Context = SideNavContext;

export type { SideNavProps, SideNavContentContainerProps, SideNavGroupToggleProps, SideNavItemProps };

export default SideNav;
